export interface AnswerObject {
  id: string | number;
  answer: string | Record<string, string> | boolean;
  is_correct: boolean;
}

export interface QuestionAnswer {
  id: number;
  answer: string;
  is_correct: boolean;
}

export const generateAnswerId = (questionType: string): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substr(2, 9);
  return `${questionType}_${timestamp}_${random}`;
};

export const createFillBlankAnswer = (
  userAnswer: string, 
  correctAnswer: string
): AnswerObject => ({
  id: generateAnswerId('fill_blank'),
  answer: userAnswer,
  is_correct: userAnswer.toLowerCase().trim() === correctAnswer?.toLowerCase().trim()
});

export const createMatchingAnswer = (
  matches: Record<string, string>,
  isCorrect: boolean
): AnswerObject => ({
  id: generateAnswerId('matching'),
  answer: matches,
  is_correct: isCorrect
});

export const findTrueFalseAnswer = (
  userAnswer: boolean,
  availableAnswers: QuestionAnswer[]
): QuestionAnswer | null => {
  return availableAnswers.find((ans) => 
    (userAnswer === true && ans.answer === 'True') || 
    (userAnswer === false && ans.answer === 'False')
  ) || null;
};

export const isValidAnswerObject = (answer: any): answer is AnswerObject => {
  return (
    answer &&
    typeof answer === 'object' &&
    (typeof answer.id === 'string' || typeof answer.id === 'number') &&
    (typeof answer.answer === 'string' || 
     typeof answer.answer === 'object' || 
     typeof answer.answer === 'boolean') &&
    typeof answer.is_correct === 'boolean'
  );
};

export const getAnswerType = (answer: AnswerObject): string => {
  if (typeof answer.answer === 'string') {
    return 'text';
  } else if (typeof answer.answer === 'object') {
    return 'matching';
  } else if (typeof answer.answer === 'boolean') {
    return 'boolean';
  }
  return 'unknown';
};

export const formatAnswerForDisplay = (answer: AnswerObject): string => {
  switch (getAnswerType(answer)) {
    case 'text':
      return answer.answer as string;
    case 'boolean':
      return answer.answer ? 'True' : 'False';
    case 'matching':
      const matches = answer.answer as Record<string, string>;
      return Object.entries(matches)
        .map(([term, definition]) => `${term} → ${definition}`)
        .join(', ');
    default:
      return 'Unknown answer type';
  }
};
